import Api from './Api';
// import PublicApi from './PublicApi';
import { createQueryString } from './ApiHelper';
import {getCountryId}  from '../helper/getCountryData'
const paramsQuery = createQueryString({
    country_id :  getCountryId()
  })

export default {
    GetAllFnbCategories(payload) {
        return Api().get(`v2/fnb/categories/${payload.cinema_id}${paramsQuery}`)
    },
    GetAllFnbItems(payload) {
        return Api().get(`v2/fnb/fnb-items/${payload.cinema_id}/${payload.category_id}`)
    },
    GetModifierGroup(payload) {
        return Api().get(`v2/fnb/modifier-group/${payload.cinema_id}/${payload.item_id}${paramsQuery}`)
    },
    GetAllModifiers(payload) {
        return Api().get(`v2/fnb/modifiers/${payload.cinema_id}/${payload.item_id}${paramsQuery}`)
    },
    AddFnb(payload) {
        return Api().get(`fnb/add-fnb${paramsQuery}`, payload)
    },
    GetRecipeItems(payload) {
        return Api().get(`v2/fnb/recipe-items/${payload.cinema_id}/${payload.item_id}${paramsQuery}`);
    }
}